export const syllabusGroups = [
  {
    id: "A",
    title: "Group A Syllabus",
    items: [
      "The Code of Civil Procedure, 1908 (Act No. V of 1908)",
      "Definitions",
      "Scope and application of the Code of Civil Procedure",
      "Meaning of suits of civil nature",
      "Jurisdiction of civil courts",
      "Res judicata and Res subjudice",
      "Place of suing",
      "Institution of suits and proceedings",
      "Parties to suits",
      "Pleadings and amendment of pleadings",
      "Plaint",
      "Written statement and set off",
      "Summons",
      "Discovery and inspection",
      "Appearance and Non-appearance of parties",
      "Examination of parties",
      "Admissions, production, impounding and return of documents",
      "Settlement of issues and disposal of suits",
      "Adjournments",
      "Hearing of the suit and examination of witnesses",
      "Affidavits",
      "Interim Orders: Arrest and attachment before judgment, Appointment of receiver, Temporary injunctions, Commission, Security for costs",
      "Alternative Dispute Resolution: Mediation, Arbitration and Mediation in appeal",
      "Transfer of suits",
      "Suits in particular cases: by/against govt/public officers, aliens, foreign rulers, corporations, trustees, minors, lunatics, public nuisance, public charities",
      "Various kinds of suits: Representative suit, Inter-pleader, Pauper suit, Money suit, Title suit etc.",
      "Withdrawal and compromise of suits",
      "Death, marriage and insolvency of parties",
      "Suits involving interpretation of the Constitution",
      "Judgement and decree",
      "Execution of decree",
      "Appeal",
      "Review",
      "Revision",
      "Reference",
      "Restitution",
      "Inherent power of the courts",
      "",
      "The Specific Relief Act, 1877 (Act No. I of 1877)",
      "Specific Relief how given",
      "Nature of preventative relief",
      "Recovery of Possession of Property",
      "Specific performance of contracts",
      "Rescission of contracts",
      "Rectification of instruments",
      "Cancellation of instruments",
      "Declaratory decrees",
      "Injunctions: Temporary & Perpetual, when granted/refused; mandatory injunction"
    ],
  },

  {
    id: "B",
    title: "Group B Syllabus",
    items: [
      "The Code of Criminal Procedure, 1898 (Act No. V of 1898)",
      "Definitions",
      "Constitution and powers of criminal courts",
      "Information of offence",
      "Arrest, escape and retaking",
      "Temporary order in urgent cases",
      "Security for keeping the peace & good behaviour",
      "Dispute as to immovable property",
      "Processes to compel appearance",
      "Processes to compel production of documents",
      "Prevention of offences",
      "Police information & powers of investigation",
      "Diary of proceedings & report of police officer",
      "Proceedings in prosecution; jurisdiction in inquiries & trials",
      "Complaints to Magistrates & commencement of proceedings",
      "Trial of cases by magistrates",
      "Summary trial",
      "Trial before the Court of Sessions",
      "General provisions as to inquiries & trials",
      "Procedure under section 195",
      "Bail: bailable & non-bailable offences",
      "Compoundable & non-compoundable offences",
      "Transfer of cases",
      "Special proceedings",
      "Public prosecutor rules",
      "Commission for examination of witnesses",
      "Trial in absentia",
      "Habeas corpus-like directions",
      "Inherent power of High Court Division",
      "Appeal",
      "Reference",
      "Revision"
    ]
  },

  {
    id: "C",
    title: "Group C Syllabus",
    items: [
      "The Penal Code, 1860 (Act No. XLV of 1860)",
      "Essential elements of an offence",
      "General explanations",
      "Acts done by several persons in furtherance of common intention",
      "Abetment",
      "Punishment: objectives & limits",
      "General exceptions",
      "Criminal conspiracy",
      "Offences against the state",
      "Offences against public tranquility",
      "Offences by/relating to public servants",
      "Contempt of lawful authority",
      "False evidence & offences against public justice",
      "Offences relating to coin and govt. stamps",
      "Offences relating to weights & measures",
      "Offences affecting public health, safety, convenience, decency & morals",
      "Offences affecting the human body",
      "Criminal intimidation",
      "Offences against property",
      "Offences relating to documents, trade/property marks, marriage",
      "Defamation",
      "Attempts to commit offences"
    ]
  },

  {
    id: "D",
    title: "Group D Syllabus",
    items: [
      "The Evidence Act, 1872 (Act No. I of 1872)",
      "Interpretation clause",
      "Facts in issue & relevancy of facts",
      "Admission & confession",
      "Statements by persons who cannot be called as witnesses",
      "Statements under special circumstances",
      "Oral evidence",
      "Documentary evidence",
      "Public & private documents",
      "Presumptions regarding documents",
      "Exclusion of oral evidence by documentary evidence",
      "Production & effect of evidence",
      "Burden of proof",
      "Estoppel",
      "Witnesses & examination",
      "Role of judges in adversarial & inquisitorial systems"
    ]
  },

  {
    id: "E",
    title: "Group E Syllabus",
    items: [
      "The Limitation Act, 1908 (Act No. IX of 1908)",
      "Objects, interpretation & application",
      "Definitions",
      "Limitation of suits, appeals, applications",
      "Legal disability",
      "Computation of limitation periods",
      "Extension/exemption of time",
      "Suspension of limitation",
      "Waiver of limitation",
      "Effect of fraud & acknowledgment",
      "Effect of payment",
      "Exclusion of time in proceedings",
      "Continuing breaches & wrongs",
      "Adverse possession",
      "Acquisition of rights to easements",
      "First Schedule (description & limitation periods)"
    ]
  },

  {
    id: "F",
    title: "Group F Syllabus",
    items: [
      "Professional Ethics, Bar Council Order & Rules, Legal Decisions and Reports",
      "Legal profession & social responsibilities",
      "Lawyers and public interest",
      "Confidentiality, transparency & accountability",
      "Oath of Advocate",
      "Canons of Professional Conduct & Etiquette",
      "Composition & functions of Bangladesh Bar Council",
      "Difference: Bar Council vs Bar Association",
      "Bar Council Tribunal: constitution, jurisdiction & procedure",
      "Bangladesh Legal Practitioners & Bar Council Rules, 1972",
      "Legal decisions & law reports"
    ]
  }
];
